// extracted by mini-css-extract-plugin
export default {"container":"CashFlowStatement_container__JbsLv","tableContainer":"CashFlowStatement_tableContainer__+BlB-"};